import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { playChime } from "@/lib/chime";

const FADE_OUT = { opacity: 0 };
const DROP_START = { y: -80, rotate: 0, opacity: 0 };
const HERO_START = { scale: 0, rotate: -30 };
const HERO_END = { scale: [0, 1.25, 1], rotate: [-30, 10, 0] };
const HERO_TIMING = { duration: 0.7, ease: "backOut" };
import { speak } from "@/lib/api";

const DROPS = Array.from({ length: 14 }, (_, i) => ({
  id: i,
  left: 4 + ((i * 37) % 92),
  delay: (i % 7) * 0.12,
  size: 28 + ((i * 13) % 26),
  spin: i % 2 ? 260 : -260,
}));

export const AcornCelebration = ({ age, answer, golden = 0 }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    playChime(golden > 0);
    const r = age === "kid" && answer ? setTimeout(() => speak(answer), 900) : null;
    const t = setTimeout(() => setShow(false), 3200);
    return () => { clearTimeout(t); clearTimeout(r); };
  }, [age, answer, golden]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div className={`pp-celebrate ${golden ? "golden" : ""}`} data-testid="acorn-celebration" exit={FADE_OUT}>
          {DROPS.map((d) => (
            <motion.img
              key={d.id}
              src="/acorn-t.png"
              alt=""
              style={{ left: `${d.left}%`, width: d.size }}
              initial={DROP_START}
              animate={{ y: "105vh", rotate: d.spin, opacity: [0, 1, 1, 0] }}
              transition={{ duration: 2.6, delay: d.delay, ease: "easeIn" }}
            />
          ))}
          <motion.img
            src="/acorn-t.png"
            alt=""
            className="pp-celebrate-hero"
            initial={HERO_START}
            animate={HERO_END}
            transition={HERO_TIMING}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
